import React from 'react';
import { Link } from 'react-router-dom';
import {FaMapMarkerAlt,FaFacebook,FaWhatsapp,FaInstagram,FaPhone,FaYoutube} from 'react-icons/fa'
const Footer = () => {
  return (
  
      <>
      <div className="footer">
        <div className="foot-cont">
                 
                  <div className='location'>
            <FaMapMarkerAlt className='map' />
            <p>9 cameroon lane, off zik avenue, uwani enugu.</p>
            <FaPhone className='map' />
            <p>08109732395</p>
            <p>08080536575</p>
             </div>
      <div className="social">
        <a href="https://www.facebook.com/profile.php?id=100057426289112"><FaFacebook className='fb'/></a>
        <a href="https://wa.me/message/7QOIJVDLJT5XO1"><FaWhatsapp className='gb'/></a>
        <a href="https://instagram.com/stories/kenneth_art247/2907103877811799179?igshid=MDJmNzVkMjY="><FaInstagram className='insta'/></a>
      
        <a href="https://youtube.com/channel/UCkWwoWn5pif9Zhmjsu1FNnw"><FaYoutube className='utube'/></a>
      
      </div>
      <h4 className='copyright'>&copy; Kenneth Art 2022</h4>
        </div>
        </div>
      </>
  )
}

export default Footer;
